import { FC } from 'react';

export const HeaderWithSpaces: FC<{ header: string }> = ({ header }) => (
  <span style={{ textTransform: 'capitalize' }}>{header.replace(/([A-Z])/g, ' $1').trim()}</span>
);
